import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, PrivateRoute} from 'react-router-dom';
import axios from "axios";


import Bpp from "./Pages/Bpp";
import Abt from "./Pages/About";
import Cnt from "./Pages/Contact";
/*import Home from "./Pages/Home";*/


import Su from "./Components/Admin/Signup";
import Lg from "./Components/Admin/Login";
import Uap from "./Components/Admin/Updateprofile";
import Ad from "./Components/Admin/Dashboard";
import Ap from "./Components/Admin/Addproductform";
import Vp from "./Components/Admin/Viewproducts";
import Uapp from "./Components/Admin/Updateproduct";


import Suc from "./Components/Customer/Signup";
import Lgc from "./Components/Customer/Login";
import Ucp from "./Components/Customer/Updateprofile";
import Cd from "./Components/Customer/Card";
import Cart from "./Components/Customer/Cart";
import Wishlist from "./Components/Customer/Wishlist";





import Mul from "./Components/Admin/Multiimg";
import Btnselect from "./Components/Othertp/btnselect"
import Cer from "./Components/Othertp/Create";
import Dyna from "./Components/Othertp/Dyna";
import Dyna1 from "./Components/Othertp/Dyna1";

axios.defaults.withCredentials=true;

function App() {

/*
  const [isAuthenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuthentication = async () => {
      try {
        const response = await axios.get('http://localhost:8000/check-auth');
        setAuthenticated(response.data.isAuthenticated);
      } catch (error) {
        console.error('Error checking authentication:', error);
      }
    };

    checkAuthentication();
  }, []);
*/


  return (
    <div className="App">
     
    <BrowserRouter>

    <Routes>

<Route path="/" element={<Bpp />} />
<Route path="/about" element={<Abt />} />
<Route path="/contact" element={<Cnt />} />
<Route path="/home" element={<Cd />} />

<Route path="/signup" element={<Su />} />
<Route path="/login" element={<Lg/>} />  {/* setAuthenticated={setAuthenticated}*/}
<Route path="/Admin_dashboard" element={<Ad />} /> {/* isAuthenticated={isAuthenticated} */}
<Route path="/Addproduct" element={<Ap />} /> {/*isAuthenticated={isAuthenticated}  */}
<Route path="/Viewproduct" element={<Vp />} /> {/*isAuthenticated={isAuthenticated} */}
<Route path="/Updateadminprofile" element={<Uap />} />  {/* isAuthenticated={isAuthenticated} */}
<Route path="/Updateproduct/:CategoryID" element={<Uapp />} />  {/* isAuthenticated={isAuthenticated} */}


<Route path="/customersignup" element={<Suc />} />
<Route path="/customerlogin" element={<Lgc />} />
<Route path="/Updatecustprofile" element={<Ucp />} />
<Route path="/Cart" element={<Cart />} />
<Route path="/Wishlist" element={<Wishlist />} />




<Route path="/Mul" element={<Mul />} />
<Route path="/Cer" element={<Cer />} />
<Route path="/btnselect" element={<Btnselect />} />
<Route path="/Dyna" element={<Dyna />} />
<Route path="/Dyna1" element={<Dyna1 />} />

</Routes>  
     
     </BrowserRouter>

    </div>
  );
}

export default App;